import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { PhoneAction } from '../constants';
import { PhoneActionType, PhoneStateType } from '../types';

export const initialState: PhoneStateType = {
  search: { account: '', campaign: '', phone: '' },
  phones: [],
  selectedPhones: [],
  campaigns: [],
  accounts: [],
  loadingPhones: false,
  assigningToCampaign: false,
  assigningToAccount: false,
  currentPage: 1,
  totalCount: 0,
  error: '',
};

const reducer: Reducer<PhoneStateType, PhoneActionType> = produce(
  (draft: Draft<PhoneStateType>, action: PhoneActionType) => {
    const { type } = action;

    switch (type) {
      case PhoneAction.SEARCH_BY_NUMBER: {
        const { phone } = action;
        draft.currentPage = 1;
        draft.search.phone = phone;
        break;
      }
      case PhoneAction.SET_PHONES: {
        const { phones, count, error } = action;
        draft.phones = phones;
        draft.totalCount = count;
        draft.error = error;
        break;
      }
      case PhoneAction.SET_CAMPAIGNS: {
        const { campaigns } = action;
        draft.campaigns = campaigns;
        break;
      }
      case PhoneAction.SET_ACCOUNTS: {
        const { accounts } = action;
        draft.accounts = accounts;
        break;
      }
      case PhoneAction.SET_LOADING_PHONES: {
        const { loading } = action;
        draft.loadingPhones = loading;
        break;
      }
      case PhoneAction.SEARCH_BY_ACCOUNT: {
        const { account } = action;
        draft.currentPage = 1;
        draft.search.account = account;
        break;
      }
      case PhoneAction.SEARCH_BY_CAMPAIGN: {
        const { campaign } = action;
        draft.currentPage = 1;
        draft.search.campaign = campaign;
        break;
      }
      case PhoneAction.SET_SELECTED_PHONES: {
        const { selectedPhones } = action;
        draft.selectedPhones = selectedPhones;
        break;
      }
      case PhoneAction.PAGINATE: {
        const { page } = action;
        draft.currentPage = page;
        break;
      }
      case PhoneAction.SET_ASSIGN_TO_CAMPAIGN: {
        const { saving } = action;
        draft.assigningToCampaign = saving;
        break;
      }
      case PhoneAction.SET_ASSIGN_TO_ACCOUNT: {
        const { saving } = action;
        draft.assigningToAccount = saving;
        break;
      }
    }
  },
  initialState
);

export const usePhonesReducer = (): [PhoneStateType, Dispatch<PhoneActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
